var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 195.219 101.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:#fff;}.a{stroke:#404040;}.a,.c{stroke-width:3px;}.b{fill:gray;font-size:17px;font-family:Montserrat-SemiBold, Montserrat;font-weight:600;}.c{fill:#1c75bc;stroke:#252a2e;}.d{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1353.596 -590.563)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(183 281)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.117,46.186q-.126.1-.258.2l-1.374,1.04S6.1,46.959,7.117,46.186Zm.8-12.7H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0H133.815a5,5,0,0,1,5,5V28.483a5,5,0,0,1-5,5H23.858c-4.215,3.2-13.083,9.926-16.741,12.7C12.179,42.11,9.8,36.487,7.914,33.483Z",
    transform: "translate(1225.5 311.063)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(1236 333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dedication"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1355.096 637.096)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 26.604,
    cy: 26.604,
    r: 26.604
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M40.622,15.08,37.233,25.69s-2.09,5.289-7.063,5.289H6.195l1.71-5.289H29.632l3.42-10.61h-21.7L13.036,9.79H36.885C42.111,9.79,40.622,15.08,40.622,15.08ZM7.05,17.93H19.909l-1.647,4.909H5.371Z",
    transform: "translate(3.56 6.489)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.3e46ece1aab4bffd075c6ead449c6361.svg";
export { ForwardRef as ReactComponent };